import { APP_MODE } from "@smile2impress/attraction-constants";

import { UrlsConfig } from "configs/urlsConfig";
import { AppMode, I18nLocale } from "constants/enum";
import { getAppMode } from "utils/getAppMode";

type UnsupportedPagesByI18nLocale = {
    [uc in UrlsConfig]?: I18nLocale[];
};

const CLUSTER_A = [
    I18nLocale.ITALY_IT,
    I18nLocale.PORTUGAL_PT,
    I18nLocale.SPAIN_ES,
    I18nLocale.FRANCE_FR,
    I18nLocale.UKRAINE_UK,
    I18nLocale.US_EN,
    I18nLocale.GB_EN,
];

const CLUSTER_B = [
    I18nLocale.NL_NL,
    I18nLocale.GERMANY_DE,
    I18nLocale.SWEDEN_SE,
];

const NON_SWEDEN = [
    I18nLocale.ITALY_IT,
    I18nLocale.PORTUGAL_PT,
    I18nLocale.SPAIN_ES,
    I18nLocale.FRANCE_FR,
    I18nLocale.UKRAINE_UK,
    I18nLocale.US_EN,
    I18nLocale.GB_EN,
    I18nLocale.NL_NL,
    I18nLocale.GERMANY_DE,
];

const DENMARK = I18nLocale.DENMARK_DK;

export const unSupportLocaleRoutesLive: UnsupportedPagesByI18nLocale = {
    [UrlsConfig.PRICES]: [DENMARK],
    [UrlsConfig.MAIN]: [DENMARK],
    [UrlsConfig.RESULTS]: [DENMARK],
    [UrlsConfig.TEENS]: [
        I18nLocale.FRANCE_FR,
        I18nLocale.NL_NL,
        I18nLocale.GERMANY_DE,
        I18nLocale.SWEDEN_SE,
        DENMARK,
    ],
    [UrlsConfig.QUIZ]: [...CLUSTER_A, ...CLUSTER_B, DENMARK],
    [UrlsConfig.ABOUT]: [
        I18nLocale.FRANCE_FR,
        I18nLocale.SPAIN_ES,
        I18nLocale.PORTUGAL_PT,
        I18nLocale.ITALY_IT,
        I18nLocale.GB_EN,
        I18nLocale.UKRAINE_UK,
        I18nLocale.NL_NL,
        I18nLocale.GERMANY_DE,
        I18nLocale.SWEDEN_SE,
        DENMARK,
    ],
    [UrlsConfig.REFERRAL]: [I18nLocale.UKRAINE_UK, DENMARK],
    [UrlsConfig.REFERRAL_FOR_FRIENDS]: [I18nLocale.UKRAINE_UK, DENMARK],
    [UrlsConfig.CANDIDATE]: [DENMARK],
    [UrlsConfig.CANDIDATE_INVISALIGN]: [
        I18nLocale.ITALY_IT,
        I18nLocale.PORTUGAL_PT,
        I18nLocale.SPAIN_ES,
        I18nLocale.FRANCE_FR,
        I18nLocale.UKRAINE_UK,
        I18nLocale.US_EN,
        I18nLocale.NL_NL,
        I18nLocale.GERMANY_DE,
        I18nLocale.SWEDEN_SE,
        DENMARK,
    ],
    [UrlsConfig.BLOG]: [DENMARK],
    [UrlsConfig.BLOG_POST]: [DENMARK],
    [UrlsConfig.DRSMILE_LEADFORM]: [
        I18nLocale.GB_EN,
        I18nLocale.UKRAINE_UK,
        I18nLocale.US_EN,
        DENMARK,
    ],
    [UrlsConfig.DRSMILE_BOOKING]: [
        I18nLocale.GB_EN,
        I18nLocale.UKRAINE_UK,
        I18nLocale.US_EN,
        DENMARK,
    ],
    [UrlsConfig.DRSMILE_THANKS_CONTACT]: [
        I18nLocale.GB_EN,
        I18nLocale.UKRAINE_UK,
        I18nLocale.US_EN,
        DENMARK,
    ],
    [UrlsConfig.CITY]: [...CLUSTER_A, DENMARK],
    [UrlsConfig.VENEERS]: [
        I18nLocale.SPAIN_ES,
        I18nLocale.ITALY_IT,
        I18nLocale.PORTUGAL_PT,
        I18nLocale.FRANCE_FR,
        I18nLocale.UKRAINE_UK,
        I18nLocale.GB_EN, // https://impress-global.atlassian.net/browse/AD-1687 (delete this line when content is ready)
        I18nLocale.US_EN,
        I18nLocale.NL_NL,
        I18nLocale.GERMANY_DE,
        I18nLocale.SWEDEN_SE,
        DENMARK,
    ],
    [UrlsConfig.COMPLAINS_FORMULAR]: [
        I18nLocale.SPAIN_ES,
        I18nLocale.ITALY_IT,
        I18nLocale.PORTUGAL_PT,
        I18nLocale.FRANCE_FR,
        I18nLocale.UKRAINE_UK,
        I18nLocale.GB_EN,
        I18nLocale.US_EN,
        I18nLocale.SWEDEN_SE,
        I18nLocale.GERMANY_DE,
        DENMARK,
    ],
    [UrlsConfig.SMAJLA_LEADFORM]: NON_SWEDEN,
    [UrlsConfig.SMAJLA_BOOKING]: NON_SWEDEN,
    [UrlsConfig.SMAJLA_THANKS_CONTACT]: NON_SWEDEN,
    [UrlsConfig.SMAJLA_TYPEFORM]: NON_SWEDEN,
    [UrlsConfig.TYPEFORM_CPH]: NON_SWEDEN,
    [UrlsConfig.SMILE_VISION_TYPEFORM]: [...CLUSTER_A, ...CLUSTER_B, DENMARK],
    [UrlsConfig.SMILE_VISION_RESULTS]: [...CLUSTER_A, ...CLUSTER_B, DENMARK],
    [UrlsConfig.SMILE_VISION_OFFER]: [
        I18nLocale.SPAIN_ES,
        I18nLocale.FRANCE_FR,
        I18nLocale.UKRAINE_UK,
        I18nLocale.US_EN,
        ...CLUSTER_B,
        DENMARK,
    ],
    [UrlsConfig.STUDENT_BEANS]: [
        I18nLocale.UKRAINE_UK,
        I18nLocale.US_EN,
        I18nLocale.SWEDEN_SE,
        DENMARK,
    ],
    [UrlsConfig.DISCOUNT]: [I18nLocale.ITALY_IT, I18nLocale.US_EN, DENMARK],
    [UrlsConfig.QUIZ_COMPLETED]: [I18nLocale.UKRAINE_UK],
};

// Attention: this list is for SUPPORTED locales. Add page and locale here to make it accessible on non-live envs
export const supportLocaleRoutesOther: UnsupportedPagesByI18nLocale = {
    [UrlsConfig.MAIN]: CLUSTER_B,
    [UrlsConfig.RETAINERS_SUBSCRIPTION]: CLUSTER_B,
    [UrlsConfig.PRICES]: CLUSTER_B,
    [UrlsConfig.CANDIDATE]: CLUSTER_B,
    [UrlsConfig.BOOKING_WIDGET]: CLUSTER_B,
    [UrlsConfig.BOOKING_SUCCESS]: CLUSTER_B,
    [UrlsConfig.QUIZ_RESULTS]: CLUSTER_B,
    [UrlsConfig.VENEERS]: [I18nLocale.GB_EN],
    [UrlsConfig.COMPLAINS_FORMULAR]: [I18nLocale.NL_NL],
    [UrlsConfig.DIASTEMA]: [...CLUSTER_B, ...CLUSTER_A],
    [UrlsConfig.REFERRAL]: CLUSTER_B,
    [UrlsConfig.REFERRAL_FOR_FRIENDS]: CLUSTER_B,
    [UrlsConfig.SMILE_VISION_TYPEFORM]: [...CLUSTER_A, ...CLUSTER_B],
    [UrlsConfig.SMILE_VISION_RESULTS]: [...CLUSTER_A, ...CLUSTER_B],
    [UrlsConfig.SMILE_VISION_OFFER]: [...CLUSTER_A, ...CLUSTER_B],
    [UrlsConfig.DISCOUNT]: [...CLUSTER_A, ...CLUSTER_B],
    [UrlsConfig.ULTRA_FORM]: [...CLUSTER_A, ...CLUSTER_B],
};

export const checkIsNotFound = (
    page: UrlsConfig,
    locale: string = I18nLocale.SPAIN_ES,
    appMode?: AppMode
) => {
    const { appMode: envAppMode } = getAppMode();
    const currentAppMode = appMode || envAppMode;

    const unsupportedLocalesLive: I18nLocale[] =
        unSupportLocaleRoutesLive[page] || [];
    const disabledForLive = unsupportedLocalesLive.includes(
        locale as I18nLocale
    );

    if (currentAppMode === APP_MODE.LIVE) return disabledForLive;
    if (!disabledForLive) return false;

    const supportedLocalesOther: I18nLocale[] | undefined =
        supportLocaleRoutesOther[page];

    const enabledForOther = supportedLocalesOther?.includes(
        locale as I18nLocale
    );
    return !enabledForOther;
};
